export default "/50f517735fec46580f19aae3e56e9fe21614ea75/08ee3b32e72dd5b2b700754671ea2016.svg";